export default () => ({
  handler: 'relativeUrl',
  data: () => '/crack-the-code',
});
